import { createFeature, createReducer, on } from '@ngrx/store';
import { LandingState } from '../types/landingState';
import * as LandingActions from './landing.actions';
import { MapLayer } from '../../../shared/classes/map-layer';

const initalState: LandingState = {
  mapLayerGroups: [],
  activeMapLayers: [],
  currentMap: undefined,
};

const removeLayer = (layers: MapLayer[], layerHandle: string) => {
  const clonedLayers = [...layers];
  const index = clonedLayers.findIndex(layer => layer.uiHandle === layerHandle);
  if (index !== -1) clonedLayers.splice(index,  1);
  return clonedLayers;
};

const landingFeature = createFeature({
  name: 'landing',
  reducer: createReducer(
    initalState,
    on(LandingActions.LoadMapLayersSuccess, (state, {mapLayerGroups}) => ({
      ...state,
      mapLayerGroups,
    })),
    on(LandingActions.SetActiveMapLayers, (state, {activeMapLayers}) => ({
      ...state,
      activeMapLayers,
    })),
    on(LandingActions.AddLayerToMap, (state, {mapLayer}) => ({
      ...state,
      activeMapLayers: [...state.activeMapLayers, mapLayer],
    })),
    on(LandingActions.RemoveLayerFromMap, (state, {layerHandle}) => ({
      ...state,
      activeMapLayers: removeLayer(state.activeMapLayers, layerHandle),
    })),
    on(LandingActions.SetCurrentMap, (state, {map}) => ({
      ...state,
      currentMap: map,
    })),
  ),
});

export const {
  name: landingFeatureKey,
  reducer: landingReducer,
  selectLandingState,
  selectMapLayerGroups,
  selectActiveMapLayers,
  selectCurrentMap,
} = landingFeature;
